import { YOU_INDICATOR_CYCLES, YOU_INDICATOR_COMPRESS_MS } from '@shared/constants.js';
import { ScreenState } from '@shared/types.js';

/**
 * Opacity (0–1) of the "you are here" indicator; 0 means hidden.
 * The indicator runs exactly YOU_INDICATOR_CYCLES compress cycles from
 * countdown start (spilling into early gameplay if the countdown is
 * shorter), then disappears for the rest of the game.
 */
export function youIndicatorAlpha(state: ScreenState, msSinceCountdownStart: number): number {
  if (state !== ScreenState.COUNTDOWN && state !== ScreenState.PLAYING) return 0;
  return msSinceCountdownStart < YOU_INDICATOR_CYCLES * YOU_INDICATOR_COMPRESS_MS ? 1 : 0;
}
